import { PolicyEvaluate } from '../interfaces/policy-evaluate.interface';

/** Stub: WorkingPeriodsPolicy evaluate. */
export const WorkingPeriodsPolicy: PolicyEvaluate<
	unknown,
	boolean,
	Record<string, unknown>
> = {
	evaluate(
		_input: unknown,
		_config: Record<string, unknown> | null | undefined,
	): boolean {
		return true;
	},
};
